export default __webpack_public_path__ + "static/media/logo-hospital-trabajador.31f0e560.png";